import { isNullable } from "../../type-guards";
export class ListUtils {
    static isDuplicated(elements) {
        const setElements = new Set(elements);
        return setElements.size !== elements.length;
    }
    static distinct(elements) {
        return elements.filter((v, i, self) => self.indexOf(v) === i);
    }
    static excludes = (source, ineligible) => {
        return source.filter((el) => !ineligible.includes(el));
    };
    static isEqual(a, b) {
        if (isNullable(a) && isNullable(b)) {
            return true;
        }
        if (isNullable(a) || isNullable(b)) {
            return false;
        }
        if (a === b) {
            return true;
        }
        if (a.length !== b.length) {
            return false;
        }
        return a.every((element, index) => {
            return element === b[index];
        });
    }
    static isSubset(subset, set) {
        return subset.every((item) => set.includes(item));
    }
    static newList(length, value) {
        return [...new Array(length)].map((_, i) => value ?? i);
    }
}
//# sourceMappingURL=list-utils.js.map